module.exports = require('error-ext') 'Attachment::LimitExceeded'



// WEBPACK FOOTER //
// ./app/scripts/views/attachment/attachment-limit-exceeded-error.coffee